// Drawer domain slice. Why isUserScrolledToBottom is store state, not context: see
// .claude/context/store-slices.md.
export const drawerSlice = (set) => ({
  isUserScrolledToBottom: false,
  setScrolledToBottom: (isAtBottom) => set({ isUserScrolledToBottom: isAtBottom }),
});
